import React from 'react';

// components
import {CircularProgress} from '@mui/joy';

// helpers
import {useTranslation} from 'react-i18next';

// styles
import {LoadingPageText, LoadingPageWrapper} from './LoadingPage-styles';

// types
type Props = {
  usePortalConfig?: boolean;
};

const LoadingPage = ({usePortalConfig = false}: Props) => {
  const {t} = useTranslation();

  return (
    <LoadingPageWrapper>
      <CircularProgress
        size="lg"
        color={usePortalConfig ? 'primary' : 'neutral'}
      />
      <LoadingPageText>{t('global_pleaseWait')}</LoadingPageText>
    </LoadingPageWrapper>
  );
};

export default LoadingPage;
